@if (src) {
	<span
		[tuiAvatar]="initials"
		[size]="size()"
		tuiAvatarOutline
		appearance="primary"
		(click)="onUploadImage()"
	>
		<img [src]="src" alt="" />
	</span>
} @else {
	<span
		[tuiAvatar]="icon() | tuiIcon"
		[size]="size()"
		tuiAvatarOutline
		(click)="onUploadImage()"
	></span>
}

@if (canUpload()) {
	<input
		#fileUploadInput
		class="avatar__file-upload"
		name="avatar"
		type="file"
		[disabled]="disabled()"
		[accept]="accept"
		[multiple]="false"
		(change)="onFileChange()"
	/>

	<button
		tuiButton
		size="xs"
		iconStart="@tui.upload"
		[disabled]="disabled()"
		appearance="outline"
		(click)="onUploadImage()"
	>
		{{ 'profile.action.upload-image' | transloco }}
	</button>

	<!-- only show the remove button if there is a thumbnail (org User only) -->
	@if (user(); as u) {
		@if (hasThumbnail(u)) {
			<button
				tuiButton
				size="xs"
				iconStart="@tui.x"
				[disabled]="disabled()"
				appearance="ghost"
				(click)="onRemoveImage()"
			>
				{{ 'profile.action.remove-image' | transloco }}
			</button>
		}
	}
}
